<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="dealerRef" :options="item.options" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Dealerachievementratetable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Dealerachievementratetable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Dealerachievementratetable from './components/dealerachievementratetable.vue'
	import utils from '../../../common/utils'
	import {
		SMSReportList,
		SMSReportCustomerQuotaExport,
		ASNVoucherType,
		InventoryClassList
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Dealerachievementratetable
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '指标类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: [{
							value: '采购指标',
							key: '1'
						}, {
							value: '销售指标',
							key: '0'
						}, ]
					},
					{
						inputdata: '',
						title: '经销商',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '230px'
					},
					{
						inputdata: '',
						title: '医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '230px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '通桥',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: []
					},
					{
						inputdata: '',
						title: '年度',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: [

						]
					},
					{
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: []
					},
					{
						inputdata: '',
						title: '金额类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: [{
							value: '标准货值',
							key: '1'
						}, {
							value: '出库金额',
							key: '2'
						}, ]
					},
				],
				from: {
					quotaType: "",
					cusName: "",
					hospital: "",
					invClass: "",
					year: "",
					status: "",
					priceColName: ""
				}
			}
		},
		mounted() {
			//this.sMSReportList()
			this.$message.warning("请填写搜索条件！");
			this.aSNVoucherType()
			this.inventoryClassList()
			this.$refs.dealerRef[0].modelvalue = this.formdata[0].options[0].value
			this.formdata[4].options = this.Year
		},
		computed: {
			// 获取去年-今年-明年
			Year() {
				let date = new Date()
				let yearStr = `${date.getFullYear() - 1}-${date.getFullYear()}-${date.getFullYear() + 1}`
				let yearArr = [{
						key: date.getFullYear() - 1,
						value: date.getFullYear() - 1,
					},
					{
						key: date.getFullYear(),
						value: date.getFullYear(),
					},
					{
						key: date.getFullYear() + 1,
						value: date.getFullYear() + 1,
					},
				]
				return yearArr
			},
		},
		methods: {
			// 列表
			async sMSReportList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code
				} = await SMSReportList({
					quotaType: Number(this.from.quotaType) || Number(this.formdata[0].options[0].key),
					cusName: this.from.cusName,
					hospital: this.from.hospital,
					invClass: this.from.invClass,
					year: this.from.year,
					status: this.from.status,
					priceColName: this.from.priceColName,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data;
					}
					loading.close();
				}
				loading.close();
			},
			// 导出
			async sMSReportCustomerQuotaExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await SMSReportCustomerQuotaExport({
					quotaType: Number(this.from.quotaType) || Number(this.formdata[0].options[0].key),
					cusName: this.from.cusName,
					hospital: this.from.hospital,
					invClass: this.from.invClass,
					year: this.from.year,
					status: this.from.status,
					priceColName: this.from.priceColName,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `经销商达成率报表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.sMSReportCustomerQuotaExport()
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[3].options.push(obj)
					})
				}
			},
			// 单据类型下拉
			async aSNVoucherType() {
				let {
					code,
					data
				} = await ASNVoucherType({})
				if (code == 0) {
					this.formdata[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[5].options.push(obj)
					})
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.sMSReportList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.sMSReportList()
			},
			select() {
				this.pageindex = 1
				try {
					this.from.quotaType = this.$refs.dealerRef[0].modelvalue
					this.from.cusName = this.$refs.dealerRef[1].modelvalue
					this.from.hospital = this.$refs.dealerRef[2].modelvalue
					this.from.invClass = this.$refs.dealerRef[3].modelvalue
					this.from.year = this.$refs.dealerRef[4].modelvalue
					this.from.status = this.$refs.dealerRef[5].modelvalue
					this.from.priceColName = this.$refs.dealerRef[6].modelvalue
					this.sMSReportList()
				} catch (error) {
					this.sMSReportList()
				}
			},
			reset() {
				this.$refs.dealerRef.map((item, index) => {
					item.modelvalue = ""
				})
			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 50px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 48px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 20px;
	}
</style>
